import React from "react";

const PencilIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 15.07 14.68">
        <polygon stroke="inherit" points="1 11.48 0.59 14.15 3.47 14.05 14.37 3.15 11.92 0.7 1 11.48"/>
        <line stroke="inherit" x1="9.94" y1="2.56" x2="12.56" y2="5.09"/>
        <line stroke="inherit" x1="2.33" y1="10.09" x2="5" y2="12.76"/>
    </svg>
);

export default PencilIcon;